<template>
  <el-dialog :visible.sync="wxpayDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="微信扫码支付" class="wxpay-dialog" center>
    <div>
      <div class="qr-code">
        <qriously :value="wxpayUrl" :size="240" level="H" />
      </div>
      <div class="prompt-text">
        请在 <span class="count-down-second">{{ countIndex }}</span> 秒内完成支付以免二维码失效。
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="btn-yellow" @click="closeWxpay">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import orderApi from '@/api/order'
export default {
  name: 'WxpayDialog',
  props: {
    orderNumber: {
      type: String,
      default: ''
    },
    orderStatus: {
      type: Number,
      default: 0
    },
    countDown: {
      type: Number,
      default: 120
    }
  },
  data() {
    return {
      wxpayDialogVisible: false,
      wxpayUrl: '',
      countIndex: 0,
      loopState: '', // P: pending, S: success, F: failure, E: end
      loopPeriod: 2000, // 轮询时间间隔
      timer: null
    }
  },
  methods: {
    show(payUrl) {
      this.wxpayUrl = payUrl
      this.wxpayDialogVisible = true
      this.processLoop()
    },
    processLoop () {
      this.countIndex = this.countDown
      this.loopState = 'P'
      const _vm = this
      this.timer = setInterval(() => {
        _vm.countIndex--
        if (_vm.countIndex === 0) {
          _vm.loopState = 'E'
        } else if (_vm.loopState === 'P') {
          _vm.checkOrderStatus()
        }
        if (_vm.loopState !== 'P') {
          _vm.postLoop()
        }
      }, this.loopPeriod)
    },
    checkOrderStatus() {

      orderApi.queryWxpayStatus(this.orderNumber, this.orderStatus).then(response => {
        if (response.data.resultCode === '0') {
          if (response.data.resultData.tradeState === 'SUCCESS') {
            this.loopState = 'S'
          }
        } else {
          this.loopState = 'F'
        }
      })
    },
    postLoop() {
      this.closeWxpay()
      if (this.loopState === 'S') {
        this.$router.push({ name: 'order-pay-success', query: { orderNumber: this.orderNumber }})
      }
      if (this.loopState === 'F') {
        this.$message.error('订单支付异常或失败，请稍后再次尝试支付。')
      }
    },
    closeWxpay() {
      clearInterval(this.timer)
      this.wxpayDialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/variables.scss';
.wxpay-dialog {
  /deep/ .el-dialog {
    width: 400px;
  }
  /deep/ .el-dialog--center .el-dialog__body {
    padding: 5px;
  }
  .qr-code {
    text-align: center;
    margin: 20px;
  }
  .prompt-text {
    text-align: center;
  }
  .count-down-second {
    color: $base-red;
  }
}
</style>
